<div class="relative">
  @if (isVideoMedia()) {
    <video
      #videoPlayer
      autoplay
      loop
      muted
      playsinline
      class="min-h-screen min-w-screen object-cover"
      [style.backgroundColor]="backgroundColor() | contentBuilderColor"
      [poster]="backgroundImage()?.url"
    >
      <source
        [src]="backgroundVideo()?.url"
        [type]="backgroundVideo()?.mime_type"
      />
      Your browser does not support the video tag.
    </video>
  } @else {
    <img
      class="min-h-screen min-w-screen object-cover"
      [src]="splashBackgroundImageUrl()"
      alt="splash screen background"
    />;
  }

  <div
    class="absolute top-0 min-h-screen cursor-pointer bg-cover bg-center"
    (click)="redirect()"
  >
    <div class="min-h-screen min-w-screen"></div>
    @if (showFooter() && !isVideoMedia()) {
      <div
        data-testid="kiosk-splash-cta-overlay"
        [class]="ctaOverlayClassList()"
        [style.backgroundColor]="backgroundColor() | contentBuilderColor"
        [style.color]="textColor() | contentBuilderColor"
        [style.opacity]="backgroundOpacity() || 1"
      >
        <button
          type="button"
          class="text-5xl font-bold leading-10"
          [class.mb-10]="hasLanguageFlags()"
        >
          {{
            labelCallToAction() || 'kiosk.splash-screen-page.default-landing-message' | translate
          }}
        </button>
        @if (hasLanguageFlags()) {
          <app-kiosk-select-language-block></app-kiosk-select-language-block>
        }
        @if (displayAccessibilityButton()) {
          <button
            type="button"
            class="hidden text-2xl underline"
            (click)="onInnerClick($event)"
          >
            {{
              labelAccessibilityButton() || 'kiosk.splash-screen-page.default-accessibility-message'
                | translate
            }}
          </button>
        }
      </div>
    } @else if (hasLanguageFlags()) {
      <div
        class="fixed bottom-10 left-0 right-0 z-10 flex justify-center"
        (click)="onInnerClick($event)"
      >
        <app-kiosk-select-language-block></app-kiosk-select-language-block>
      </div>
    }
  </div>
</div>
